var render, staticRenderFns
import script from "./UIButton.vue?vue&type=script&lang=ts&"
export * from "./UIButton.vue?vue&type=script&lang=ts&"
import style0 from "./UIButton.vue?vue&type=style&index=0&module=true&lang=postcss&"
import style1 from "./UIButton.vue?vue&type=style&index=1&id=04df8d7e&scoped=true&lang=postcss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../vue-loader-virtual-c5444c0a66/0/cache/vue-loader-npm-15.9.1-90a0e5830b-a9a3ffbe3c.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "04df8d7e",
  null
  
)

export default component.exports